import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

import { computed } from "vue";
import { CreatorTab } from "@/types";
import { permissionStore, projectStore, useScreen } from "@/hooks";
import { navigateTo, QueryParams, Routes } from "@/router";
import {
  ExternalLinks,
  PrivatePage,
  FlexBox,
  Typography,
  PanelCard,
  TextButton,
  ProjectVersionStepper,
  FlexItem,
} from "@/components";


/**
 * Displays the home page.
 */
const __default__ = {
  name: "HomeView",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { smallWindow } = useScreen();

const displayDemo = computed(() => permissionStore.isDemo);
const displayProjects = computed(
  () => !displayDemo.value && projectStore.allProjects.length > 0
);

function handleOpenBulk() {
  navigateTo(Routes.PROJECT_CREATOR, {
    [QueryParams.TAB]: "bulk" as CreatorTab,
  });
}

function handleOpenImport() {
  navigateTo(Routes.PROJECT_CREATOR, {
    [QueryParams.TAB]: "import" as CreatorTab,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PrivatePage), { "small-window": "" }, {
    default: _withCtx(() => [
      _createVNode(_unref(FlexBox), {
        column: _unref(smallWindow),
        "full-width": ""
      }, {
        default: _withCtx(() => [
          (displayDemo.value)
            ? (_openBlock(), _createBlock(_unref(FlexItem), {
                key: 0,
                style: {"width":"80vw"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(PanelCard), {
                    title: "Public SAFA Projects",
                    icon: "nav-open"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Typography), {
                        variant: "small",
                        value: "Browse through our collection of public datasets with documentation generated by SAFA."
                      }),
                      _createVNode(_unref(ProjectVersionStepper), { minimal: "" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (displayProjects.value)
            ? (_openBlock(), _createBlock(_unref(FlexItem), {
                key: 1,
                parts: _unref(smallWindow) ? '12' : '7'
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_unref(smallWindow) ? '' : 'q-mr-md')
                  }, [
                    _createVNode(_unref(PanelCard), {
                      title: "Load Existing Project",
                      icon: "nav-open"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Typography), {
                          variant: "small",
                          value: "Select an existing project and version to load."
                        }),
                        _createVNode(_unref(ProjectVersionStepper), { minimal: "" })
                      ]),
                      _: 1
                    })
                  ], 2)
                ]),
                _: 1
              }, 8, ["parts"]))
            : _createCommentVNode("", true),
          (!displayDemo.value)
            ? (_openBlock(), _createBlock(_unref(FlexItem), {
                key: 2,
                parts: _unref(smallWindow) || !displayProjects.value ? '12' : '5'
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(PanelCard), {
                    title: "Create New Project",
                    icon: "project-add"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Typography), {
                        variant: "small",
                        value: "Chose which data source you would like to create a project from."
                      }),
                      _createVNode(_unref(FlexBox), {
                        "full-width": "",
                        justify: "center",
                        t: "2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FlexBox), { column: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(TextButton), {
                                text: "",
                                label: "Import From GitHub",
                                icon: "integrate",
                                color: "primary",
                                onClick: handleOpenImport
                              }),
                              _createVNode(_unref(TextButton), {
                                text: "",
                                label: "Upload From Files",
                                icon: "upload",
                                color: "primary",
                                onClick: handleOpenBulk
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(ExternalLinks))
                ]),
                _: 1
              }, 8, ["parts"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["column"])
    ]),
    _: 1
  }))
}
}

})